import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import BunnyKlawzSearchItem from './PortfolioWindow/BunnyKlawzSearchItem';
import CatHouseSearchItem from './PortfolioWindow/CatHouseSearchItem';
import BiteMeBakerySearchItem from './PortfolioWindow/BiteMeBakerySearchItem';
import BunnyKlawzWebsite from './PortfolioWindow/BunnyKlawzWebsite';
import CatHouseWebsite from './PortfolioWindow/CatHouseWebsite';
import BiteMeBakeryWebsite from './PortfolioWindow/BiteMeBakeryWebsite';

const PortfolioWindow = ({ isPortfolioOpen, setIsPortfolioOpen, zFILO, addToZFILO, removeFromZFILO }) => {
    const [selectedSite, setSelectedSite] = useState(null); // "bunny", "cathouse", "bakery"

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (location.pathname.startsWith('/portfolio/bunny')) {
            setSelectedSite('bunny');
        } else if (location.pathname.startsWith('/portfolio/cathouse')) {
            setSelectedSite('cathouse');
        } else if (location.pathname.startsWith('/portfolio/bakery')) {
            setSelectedSite('bakery');
        } else if (location.pathname === '/portfolio') {
            setSelectedSite(null);
        }
    }, [location.pathname]);

    const zIndex = zFILO.indexOf('portfolio') !== -1 ? 1000 + zFILO.indexOf('portfolio') : 1000;

    const handleClose = () => {
        setIsPortfolioOpen(false);
        removeFromZFILO('portfolio');
        navigate('/');
    };

    const handleMinimize = () => {
        setIsPortfolioOpen(false);
        removeFromZFILO('portfolio');
        navigate('/');
    };

    if (!isPortfolioOpen) return null;

    return (
        <div className='PortfolioWindow DesktopWindow' style={{ zIndex }}>
            <div className='PortfolioWindowTitleBar DesktopWindowTitleBar'>
                <span className='Title'>Portfolio Explorer</span>
                <div className='ResizeButtons'>
                    <img
                        src='/images/MinimizeIcon.png'
                        alt='Minimize'
                        className='MinimizeButton'
                        onClick={handleMinimize}
                    />
                    <img src='/images/MaximizeIcon.png' alt='Maximize' />
                    <img
                        src='/images/SystemMessageCloseButton.png'
                        alt='Close'
                        className='CloseButton'
                        onClick={handleClose}
                    />
                </div>
            </div>
            <div className='PortfolioWindowNavigationBar'>
                <div className='PortfolioWindowNavigationBarLeft'>
                    <img
                        src='/images/PortfolioBackIcon.png'
                        alt='Back'
                        onClick={() => {
                            setSelectedSite(null);
                            navigate('/portfolio');
                        }}
                    />
                    <img src='/images/PortfolioForwardIcon.png' alt='Forward' />
                    <div className='PortfolioSearchContainer SearchContainer'>
                        <input value={`https://WAAS.Portfolio.Explorer.com`} readOnly />
                        <img src='/images/SearchIcon.png' alt='Search' />
                    </div>
                </div>
                <div className='PortfolioWindowNavigationBarRight'>
                    <img src='/images/BookmarkIcon.png' alt='Bookmark' />
                    <img
                        src='/images/HomeIcon.png'
                        alt='Home'
                        onClick={() => {
                            setSelectedSite(null);
                            navigate('/portfolio');
                        }}
                    />
                </div>
            </div>
            {!selectedSite && (
                <>
                    <Helmet>
                        <title>Portfolio | We Are A Site</title>
                        <meta name="description" content="Browse our custom websites for real small businesses. See what we can build for you!" />
                    </Helmet>
                    <div className='PortfolioResults'>
                        <span className='SearchResultIndex'>4 results found for "WAAS Portfolio"</span>
                        <div className='PortfolioWebsiteContainer'>
                            <BunnyKlawzSearchItem selectedSite={selectedSite} setSelectedSite={setSelectedSite} />
                            {/* <CatHouseSearchItem selectedSite={selectedSite} setSelectedSite={setSelectedSite} />
                        <BiteMeBakerySearchItem selectedSite={selectedSite} setSelectedSite={setSelectedSite} /> */}
                            <div className='PortfolioSearchItem SearchItem' style={{ cursor: 'not-allowed' }}>
                                <img src='/images/DoubleTSodIcon.png' alt='Preview' style={{ backgroundColor: "white" }} />
                                <div className='SearchItemInfo'>
                                    <h1 className='Title'>Double-T Sod</h1>
                                    {/* <a className='URL' href={url} target='_blank' rel='noopener noreferrer'>{url}</a> */}
                                    {/* <a className='URL'>{url}</a> */}
                                    <span className='Description'>Coming Soon ...</span>
                                </div>
                            </div>

                            <div className='PortfolioSearchItem SearchItem' style={{ cursor: 'not-allowed' }}>
                                <img src='/images/CatHouseTattooIcon.png' alt='Preview' />
                                <div className='SearchItemInfo'>
                                    <h1 className='Title'>CATHOUSE Tattoo</h1>
                                    {/* <a className='URL' href={url} target='_blank' rel='noopener noreferrer'>{url}</a> */}
                                    {/* <a className='URL'>{url}</a> */}
                                    <span className='Description'>Coming Soon ...</span>
                                </div>
                            </div>
                            <div className='PortfolioSearchItem SearchItem' style={{ cursor: 'not-allowed' }}>
                                <img src='/images/BiteMeBakeryIcon.png' alt='Preview' />
                                <div className='SearchItemInfo'>
                                    <h1 className='Title'>BiteMe Bakery AZ</h1>
                                    {/* <a className='URL' href={url} target='_blank' rel='noopener noreferrer'>{url}</a> */}
                                    {/* <a className='URL'>{url}</a> */}
                                    <span className='Description'>Coming Soon ...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </>

            )}
            {selectedSite === 'bunny' && <BunnyKlawzWebsite />}
            {selectedSite === 'cathouse' && <CatHouseWebsite />}
            {selectedSite === 'bakery' && <BiteMeBakeryWebsite />}
        </div>
    );
};

export default PortfolioWindow;
